var _ellipse, _g, _ellipse2, _rect, _g2, _g3, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileNoAccowner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 347,
    viewBox: "0 0 425 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.18,
    filter: "url(#filter0_f_441_100099)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.657,
    cy: 123.507,
    rx: 71.867,
    ry: 70.5836,
    fill: "#49E0B3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    filter: "url(#filter1_f_441_100099)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 274.745,
    cy: 162.81,
    r: 68.0169,
    fill: "#190DA0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.43,
    filter: "url(#filter2_f_441_100099)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.426,
    cy: 180.736,
    rx: 84.7003,
    ry: 84.0587,
    fill: "#5B4B9B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.34,
    y: 89.5059,
    width: 167.117,
    height: 167.117,
    rx: 83.5587,
    fill: "url(#paint0_linear_441_100099)",
    stroke: "url(#paint1_linear_441_100099)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.81 191.645V209.611",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.826 200.629H358.793",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.41 227.471V237.951",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.17 232.711H339.651",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.349 59.6348V97.8141",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.259 78.7246H141.438",
    stroke: "#00DA99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_441_100099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.8677,
    y: 127.193,
    width: 176.799,
    height: 56.5757,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 95.8677,
    y: 134.48,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#B2D4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 162.267C128.048 162.268 127.492 162.463 127.044 162.819C126.596 163.175 126.281 163.672 126.151 164.23H119.482C119.374 163.769 119.139 163.347 118.805 163.013C118.47 162.678 118.048 162.443 117.587 162.335V158.988H126.697C127.699 158.988 128.661 158.59 129.369 157.881C130.078 157.173 130.476 156.212 130.476 155.209C130.476 154.207 130.078 153.246 129.369 152.537C128.661 151.828 127.699 151.43 126.697 151.43H126.172C125.801 150.333 125.027 149.418 124.008 148.868C122.988 148.318 121.799 148.174 120.678 148.466C120.089 147.023 119.017 145.829 117.646 145.089C116.274 144.348 114.688 144.107 113.159 144.406C111.629 144.706 110.251 145.527 109.26 146.729C108.268 147.932 107.725 149.441 107.723 151C107.723 151.14 107.729 151.283 107.739 151.43H107.33C106.327 151.43 105.366 151.828 104.657 152.536C103.949 153.245 103.551 154.206 103.551 155.209C103.551 156.211 103.949 157.172 104.657 157.881C105.366 158.59 106.327 158.988 107.33 158.988H116.439V162.335C115.978 162.443 115.557 162.677 115.222 163.012C114.887 163.347 114.653 163.768 114.544 164.229H107.875C107.734 163.623 107.375 163.089 106.866 162.73C106.357 162.371 105.734 162.212 105.115 162.283C104.497 162.354 103.926 162.65 103.511 163.115C103.097 163.58 102.868 164.181 102.868 164.803C102.868 165.426 103.097 166.027 103.511 166.492C103.926 166.957 104.497 167.253 105.115 167.324C105.734 167.394 106.357 167.235 106.866 166.877C107.375 166.518 107.734 165.984 107.875 165.378H114.544C114.674 165.936 114.988 166.433 115.436 166.79C115.885 167.146 116.441 167.34 117.013 167.34C117.586 167.34 118.142 167.146 118.59 166.79C119.039 166.433 119.353 165.936 119.482 165.378H126.151C126.259 165.842 126.496 166.267 126.835 166.603C127.173 166.939 127.6 167.172 128.065 167.277C128.531 167.382 129.016 167.353 129.466 167.194C129.915 167.035 130.311 166.753 130.608 166.379C130.904 166.006 131.089 165.556 131.142 165.082C131.194 164.608 131.112 164.128 130.905 163.699C130.697 163.27 130.373 162.907 129.968 162.654C129.564 162.401 129.097 162.266 128.62 162.267V162.267ZM105.407 166.192C105.132 166.192 104.864 166.111 104.636 165.958C104.407 165.806 104.229 165.589 104.124 165.335C104.019 165.082 103.992 164.802 104.045 164.533C104.099 164.264 104.231 164.016 104.425 163.822C104.619 163.628 104.867 163.496 105.136 163.442C105.405 163.389 105.684 163.416 105.938 163.521C106.192 163.626 106.409 163.804 106.561 164.033C106.714 164.261 106.795 164.529 106.795 164.804C106.795 165.172 106.648 165.525 106.388 165.785C106.128 166.045 105.775 166.192 105.407 166.192ZM107.33 157.839C106.632 157.839 105.963 157.562 105.47 157.069C104.976 156.575 104.699 155.906 104.699 155.209C104.699 154.511 104.976 153.842 105.47 153.349C105.963 152.855 106.632 152.578 107.33 152.578H108.388C108.471 152.578 108.553 152.56 108.629 152.525C108.704 152.49 108.771 152.439 108.825 152.376C108.879 152.312 108.919 152.238 108.941 152.158C108.963 152.077 108.968 151.993 108.955 151.911C108.722 150.517 109.029 149.087 109.812 147.91C110.594 146.733 111.795 145.898 113.17 145.573C114.546 145.248 115.993 145.458 117.22 146.16C118.446 146.862 119.36 148.004 119.777 149.355C119.8 149.431 119.839 149.501 119.891 149.561C119.943 149.622 120.007 149.67 120.079 149.705C120.151 149.739 120.229 149.758 120.308 149.76C120.388 149.762 120.467 149.748 120.541 149.718C121.001 149.531 121.497 149.446 121.994 149.47C122.491 149.493 122.977 149.624 123.418 149.854C123.859 150.083 124.245 150.406 124.549 150.799C124.853 151.193 125.069 151.648 125.18 152.132C125.209 152.259 125.28 152.372 125.381 152.452C125.482 152.533 125.608 152.578 125.737 152.578H126.696C127.394 152.578 128.063 152.855 128.556 153.349C129.05 153.842 129.327 154.511 129.327 155.209C129.327 155.906 129.05 156.575 128.556 157.069C128.063 157.562 127.394 157.839 126.696 157.839H107.33ZM117.013 166.192C116.739 166.192 116.47 166.111 116.242 165.958C116.014 165.806 115.836 165.589 115.731 165.335C115.626 165.081 115.598 164.802 115.652 164.533C115.706 164.264 115.838 164.016 116.032 163.822C116.226 163.628 116.474 163.496 116.743 163.442C117.012 163.389 117.291 163.416 117.545 163.521C117.799 163.626 118.015 163.804 118.168 164.033C118.32 164.261 118.402 164.529 118.402 164.804C118.401 165.172 118.255 165.525 117.995 165.785C117.734 166.046 117.381 166.192 117.013 166.192ZM128.62 166.192C128.345 166.192 128.077 166.111 127.849 165.958C127.621 165.806 127.443 165.589 127.338 165.335C127.233 165.081 127.205 164.802 127.259 164.533C127.312 164.264 127.445 164.016 127.639 163.822C127.833 163.628 128.08 163.496 128.35 163.442C128.619 163.389 128.898 163.416 129.152 163.521C129.405 163.626 129.622 163.804 129.775 164.033C129.927 164.261 130.009 164.529 130.009 164.804C130.008 165.172 129.862 165.525 129.601 165.785C129.341 166.046 128.988 166.192 128.62 166.192Z",
    fill: "#65AAA3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.868,
    y: 152.48,
    width: 104.799,
    height: 6,
    fill: "#F2F2F7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_441_100099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.411,
    y: 78.3965,
    width: 176.799,
    height: 56.5757,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 198.411,
    y: 85.6836,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.924 96.8938C232.908 96.8938 233.663 96.0734 233.663 95.1219C233.663 94.1703 232.875 93.4156 231.924 93.3828H207.183C206.199 93.3828 205.444 94.2031 205.444 95.1547C205.444 96.1063 206.231 96.8609 207.183 96.8938H207.478V110.938H207.183C206.199 110.938 205.411 111.725 205.411 112.709C205.411 113.694 206.199 114.481 207.183 114.481H218.963V116.286C218.142 116.614 217.716 117.533 218.044 118.353C218.372 119.173 219.291 119.6 220.111 119.272C220.931 118.944 221.358 118.025 221.03 117.205C220.866 116.778 220.538 116.45 220.111 116.286V114.481H231.891C232.875 114.481 233.663 113.694 233.663 112.709C233.663 111.725 232.875 110.938 231.891 110.938H231.596V96.8938H231.924ZM219.553 118.189C219.291 118.189 219.094 117.992 219.094 117.73C219.094 117.467 219.291 117.27 219.553 117.27C219.816 117.27 220.013 117.467 220.013 117.73C220.013 117.992 219.816 118.189 219.553 118.189ZM231.924 112.086C232.252 112.086 232.547 112.348 232.547 112.709C232.547 113.038 232.285 113.333 231.924 113.333H207.183C206.855 113.333 206.56 113.07 206.56 112.709C206.56 112.381 206.822 112.086 207.183 112.086H231.924ZM208.66 110.938V96.8938H230.48V110.938H208.66ZM207.183 95.7453C206.855 95.7453 206.592 95.45 206.592 95.1219C206.592 94.7937 206.855 94.5312 207.183 94.5312H231.891C232.219 94.5312 232.481 94.8266 232.481 95.1547C232.481 95.4828 232.219 95.7453 231.891 95.7453C227.691 95.7453 210.366 95.7453 207.183 95.7453Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.964 99.7816C220.734 99.552 220.373 99.552 220.144 99.7816L218.339 101.586C218.109 101.816 218.109 102.177 218.339 102.407C218.569 102.636 218.93 102.636 219.127 102.407L219.947 101.586V103.194C219.947 105.327 218.208 107.066 216.075 107.066C215.747 107.066 215.484 107.329 215.484 107.657C215.484 107.985 215.747 108.247 216.075 108.247C218.864 108.247 221.095 105.983 221.095 103.227V101.586L221.916 102.407C222.145 102.636 222.506 102.636 222.736 102.407C222.966 102.177 222.966 101.816 222.736 101.619L220.964 99.7816Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.384 98.9277C212.203 98.9277 211.219 99.9121 211.219 101.093C211.219 102.275 212.203 103.259 213.384 103.259C214.566 103.259 215.55 102.275 215.55 101.093C215.55 99.8793 214.566 98.9277 213.384 98.9277ZM213.384 102.111C212.827 102.111 212.367 101.651 212.367 101.093C212.367 100.536 212.827 100.076 213.384 100.076C213.942 100.076 214.402 100.536 214.402 101.093C214.402 101.651 213.942 102.111 213.384 102.111Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.133 105.327C226.903 105.097 226.542 105.097 226.313 105.327L225.591 106.048L224.869 105.327C224.639 105.097 224.278 105.097 224.049 105.327C223.819 105.556 223.819 105.917 224.049 106.147L224.771 106.869L224.049 107.591C223.819 107.82 223.819 108.181 224.049 108.411C224.278 108.641 224.639 108.641 224.869 108.411L225.591 107.689L226.313 108.411C226.542 108.641 226.903 108.641 227.133 108.411C227.363 108.181 227.363 107.82 227.133 107.591L226.411 106.869L227.133 106.147C227.363 105.917 227.363 105.556 227.133 105.327Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.411,
    y: 103.684,
    width: 104.799,
    height: 6,
    fill: "#F2F2F7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_441_100099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.228,
    y: 189.426,
    width: 176.799,
    height: 56.5757,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 131.228,
    y: 196.713,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#F3DF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.918 231.997H163.067C163.395 231.997 163.657 231.735 163.657 231.407V209.98C163.657 209.816 163.592 209.685 163.493 209.586L157.784 203.877C157.685 203.779 157.554 203.713 157.39 203.713H140.918C140.59 203.713 140.36 203.975 140.328 204.304V231.439C140.36 231.735 140.59 231.997 140.918 231.997ZM157.948 205.682C159.26 206.994 160.376 208.11 161.689 209.422H157.948V205.682ZM141.509 204.861H156.832V209.98C156.832 210.308 157.095 210.538 157.423 210.571H162.542V230.849H141.542V204.861H141.509Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.293 217.298H158.506C158.21 214.115 155.717 211.621 152.567 211.359V210.571C152.567 210.243 152.304 209.98 151.976 209.98C151.648 209.98 151.385 210.243 151.385 210.571V211.359C148.235 211.654 145.742 214.148 145.446 217.298H144.692C144.364 217.298 144.101 217.56 144.101 217.888C144.101 218.216 144.364 218.479 144.692 218.479H145.479C145.775 221.629 148.268 224.123 151.418 224.418V225.205C151.418 225.534 151.681 225.796 152.009 225.796C152.337 225.796 152.6 225.534 152.6 225.205V224.418C155.75 224.123 158.243 221.629 158.539 218.479H159.326C159.654 218.479 159.917 218.216 159.917 217.888C159.917 217.56 159.621 217.298 159.293 217.298ZM156.635 218.446H157.357C157.095 220.973 155.093 222.974 152.567 223.237V222.515C152.567 222.187 152.304 221.924 151.976 221.924C151.648 221.924 151.385 222.187 151.385 222.515V223.237C148.859 222.974 146.857 220.973 146.595 218.446H147.317C147.645 218.446 147.907 218.184 147.907 217.855C147.907 217.527 147.645 217.265 147.317 217.265H146.595C146.857 214.738 148.859 212.737 151.385 212.474V213.196C151.385 213.524 151.648 213.787 151.976 213.787C152.304 213.787 152.567 213.524 152.567 213.196V212.474C155.093 212.737 157.095 214.738 157.357 217.265H156.635C156.307 217.265 156.045 217.527 156.045 217.855C156.045 218.184 156.307 218.446 156.635 218.446Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.009 215.492C150.729 215.492 149.679 216.542 149.679 217.855C149.679 219.167 150.729 220.217 152.009 220.217C153.289 220.217 154.371 219.167 154.371 217.855C154.339 216.575 153.289 215.525 152.009 215.492ZM152.009 219.069C151.353 219.069 150.828 218.544 150.828 217.855C150.828 217.166 151.353 216.673 152.042 216.673C152.698 216.673 153.223 217.198 153.223 217.855C153.19 218.511 152.665 219.036 152.009 219.069Z",
    fill: "#E8BF39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.228,
    y: 214.713,
    width: 104.799,
    height: 6,
    fill: "#F2F2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_441_100099",
    x: 24.79,
    y: 0.923828,
    width: 247.734,
    height: 245.168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_441_100099"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_441_100099",
    x: 124.728,
    y: 12.793,
    width: 300.034,
    height: 300.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_441_100099"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_441_100099",
    x: 0.725586,
    y: 14.6777,
    width: 333.401,
    height: 332.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_441_100099"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_441_100099",
    x: 65.8677,
    y: 112.193,
    width: 216.799,
    height: 96.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_100099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_441_100099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_441_100099",
    x: 168.411,
    y: 63.3965,
    width: 216.799,
    height: 96.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_100099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_441_100099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_441_100099",
    x: 101.228,
    y: 174.426,
    width: 216.799,
    height: 96.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_441_100099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_441_100099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_100099",
    x1: 59.5934,
    y1: -15.3281,
    x2: 381.793,
    y2: 116.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_441_100099",
    x1: 146.411,
    y1: 108.938,
    x2: 263.195,
    y2: 241.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFE2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5BFF",
    stopOpacity: 0.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNoAccowner);
export default __webpack_public_path__ + "static/media/profile-no-accowner.fd9fd6fcedf67a0e341291b836358cae.svg";
export { ForwardRef as ReactComponent };